import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "grey--text caption"
}
const _hoisted_2 = ["colspan"]
const _hoisted_3 = { class: "d-flex align-center justify-space-around pa-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "grey--text d-none d-md-block" }, "Items per page", -1)
const _hoisted_5 = { class: "grey--text d-none d-sm-block" }
const _hoisted_6 = { class: "grey--text d-none d-md-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_support_object = _resolveComponent("support-object")!
  const _component_from_now = _resolveComponent("from-now")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createBlock(_component_v_data_table, {
    modelValue: _ctx.selectedItems,
    "onUpdate:modelValue": [
      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedItems) = $event)),
      _cache[4] || (_cache[4] = (a) => _ctx.updateModelValue(a))
    ],
    "onUpdate:page": [
      _ctx.updateEvent,
      _cache[6] || (_cache[6] = ($event: any) => ((_ctx.page) = $event))
    ],
    expanded: _ctx.expanded,
    "onUpdate:expanded": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.expanded) = $event)),
    page: _ctx.page,
    pageModifiers: { sync: true },
    headers: _ctx.columnsSelected,
    search: _ctx.searchText,
    "filter-mode": 'some',
    "filter-keys": _ctx.keys,
    title: _ctx.title,
    "items-per-page": _ctx.itemsPerPage,
    "onUpdate:itemsPerPage": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.itemsPerPage) = $event)),
    "items-per-pageModifiers": { sync: true },
    "items-per-page-options": _ctx.itemsPerPageArray,
    "items-per-page-text": 'Items per page',
    items: _ctx.searchData,
    "item-value": 'id',
    density: "compact",
    "expand-on-click": "",
    "fixed-header": "",
    "hide-default-footer": "",
    hover: "",
    "multi-sort": "",
    "show-expand": true,
    "show-select": true,
    returnObject: true,
    sticky: "",
    showCurrentPage: true,
    pagination: _ctx.pagination,
    "onUpdate:pagination": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pagination) = $event))
  }, {
    top: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, {
                dark: "",
                color: "white",
                class: "px-2 mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.searchText,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                    clearable: "",
                    "hide-details": "",
                    "prepend-inner-icon": "mdi-magnify",
                    label: "Search in table",
                    placeholder: "Type a value to search in table",
                    variant: "solo",
                    density: "comfortable"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!_ctx.xs)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12",
                sm: "6",
                md: "9"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.columnsSelected,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.columnsSelected) = $event)),
                    items: _ctx.columnsAll,
                    label: "Select columns",
                    multiple: "",
                    outlined: "",
                    "return-object": ""
                  }, {
                    selection: _withCtx(({ item, index }) => [
                      (index < _ctx.columnListVisible)
                        ? (_openBlock(), _createBlock(_component_v_chip, { key: 0 }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (index === _ctx.columnListVisible)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(+" + _toDisplayString(_ctx.columnsSelected.length - _ctx.columnListVisible) + " others)", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "items"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    "no-data": _withCtx(() => [
      _createVNode(_component_v_alert, {
        class: "ma-2",
        type: "warning"
      }, {
        default: _withCtx(() => [
          _createTextVNode("No coincident results")
        ]),
        _: 1
      })
    ]),
    "expanded-row": _withCtx(({ columns, item, isExpanded }) => [
      _createElementVNode("tr", null, [
        _createElementVNode("td", {
          colspan: columns.length
        }, [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "subheading font-weight-bold" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.raw.name) + " " + _toDisplayString(item.raw.last_name), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_card_subtitle, null, {
                default: _withCtx(() => [
                  _createTextVNode("ID "),
                  _createElementVNode("b", null, _toDisplayString(item.raw.id), 1),
                  _createTextVNode(_toDisplayString(item.raw.username ? ' | ':''), 1),
                  _createElementVNode("b", null, _toDisplayString(item.raw.username ? `${item.raw.username}` : ''), 1),
                  _createTextVNode(" | TYPE "),
                  _createElementVNode("b", null, _toDisplayString(item.raw.profile_type), 1),
                  _createTextVNode(" | STATUS "),
                  _createElementVNode("b", null, _toDisplayString(item.raw.status), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_v_divider),
          (isExpanded(item))
            ? (_openBlock(), _createBlock(_component_support_object, {
                key: 0,
                target: _ctx.getItemTarget(item),
                id: item.raw.id,
                title: ""
              }, null, 8, ["target", "id"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_divider)
        ], 8, _hoisted_2)
      ])
    ]),
    "item.created_at": _withCtx(({ item }) => [
      _createVNode(_component_from_now, {
        date: item.raw.created_at
      }, null, 8, ["date"])
    ]),
    bottom: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_v_menu, {
          bottom: "",
          left: "",
          "open-on-click": "",
          "open-on-hover": ""
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({
              variant: "text",
              color: "primary",
              class: "ml-2",
              "append-icon": "mdi-chevron-down"
            }, props), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.itemsPerPage > 0 ? _ctx.itemsPerPage : 'All'), 1)
              ]),
              _: 2
            }, 1040)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPerPageArray, (numberObj, index) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    "model-value": _ctx.itemsPerPage,
                    key: numberObj.value,
                    title: numberObj.title,
                    onClick: ($event: any) => (_ctx.itemsPerPage = numberObj.value)
                  }, null, 8, ["model-value", "title", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer, { class: "d-none d-md-block" }),
        _createElementVNode("span", _hoisted_5, _toDisplayString(`${((_ctx.page - 1) * _ctx.itemsPerPage) + 1}-${Math.min(_ctx.page * _ctx.itemsPerPage,_ctx.searchResultCount > 0 ? _ctx.searchResultCount : _ctx.inputData.length)}`), 1),
        _createElementVNode("span", _hoisted_6, " " + _toDisplayString(`of ${_ctx.searchResultCount > 0 ? `${_ctx.searchResultCount} filtered` : `${_ctx.inputData.length} total` } ${ _ctx.selectedItems.length > 0 ? ` (${_ctx.selectedItems.length} pinned)` : '' }`), 1),
        _createVNode(_component_v_pagination, {
          modelValue: _ctx.page,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.page) = $event)),
          length: _ctx.numberOfPages,
          "total-visible": _ctx.pagesVisible,
          ellipsis: "-",
          border: true,
          "show-first-last-page": ""
        }, null, 8, ["modelValue", "length", "total-visible"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:page", "expanded", "page", "headers", "search", "filter-keys", "title", "items-per-page", "items-per-page-options", "items", "pagination"]))
}